export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.template': '模板示例',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.luole-admin.dashboard': '首頁',
  'menu.luole-admin.architect-talent-ops': '人才端',
  'menu.luole-admin.architect-talent-ops.overview': '營運總覽',
  'menu.luole-admin.architect-talent-ops.applications': '投遞明細',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.overview':
    '營運總覽',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.applications':
    '投遞明細',
  'menu.luole-admin.architect-talent-ops.luole-admin.member.management':
    '人才庫',
  'menu.luole-admin.architect-talent-ops.luole-admin.member.analytics':
    '人才畫像',
  'menu.luole-admin.architect-talent-ops.luole-admin.inviteManagement':
    '邀請管理',
  'menu.luole-admin.architect-talent-ops.luole-admin.schoolShowcase':
    '高校風采',
  'menu.luole-admin.architect-talent-ops.luole-admin.carousel.management':
    '輪播圖',
  'menu.luole-admin.architect-talent-ops.luole-admin.contentMarketing.management':
    '內容行銷',
  'menu.luole-admin.recruitment-assistant-ops': '企業端',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.overview':
    '運營總覽',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.ai-job-monitor':
    'AI職位匹配監控',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait':
    '企業畫像',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait.detail':
    '企業畫像詳情',
  'menu.luole-admin.campus-ops': '高校端運營',
  'menu.luole-admin.institution.verify': '高校認證審核',
  'menu.luole-admin.campus-ops.luole-admin.institution.verify': '高校認證審核',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops':
    '高校端運營',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.list':
    '企業庫',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.users':
    '企業用戶',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.verify':
    '企業認證',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.institution.verify':
    '高校認證審核',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops.luole-admin.institution.verify':
    '高校認證審核',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.demoReservation':
    '企業預約演示',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.userFeedback':
    '用戶反饋',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.registrationChannels':
    '渠道管理',
  'menu.luole-admin.recruitment': '招聘管理',
  'menu.luole-admin.activity': '活動管理',
  'menu.luole-admin.system': '系統設置',
  'menu.luole-admin.system.role-permissions': '角色權限',
  'menu.luole-admin.system.members': '成員管理',
  'menu.luole-admin.content': '內容配置',
  'menu.luole-admin.feedback': '反饋管理',
  'menu.luole-admin.analytics.recruitment': '招聘運營看板',
  'menu.luole-admin.job.management': '職位管理',
  'menu.luole-admin.member.management': '人才庫',
  'menu.luole-admin.member.analytics': '人才畫像',
  'menu.luole-admin.inviteManagement': '邀請管理',
  'menu.luole-admin.enterprise': '企業管理',
  'menu.luole-admin.enterprise.list': '企業庫',
  'menu.luole-admin.enterprise.users': '企業用戶',
  'menu.luole-admin.enterprise.verify': '企業認證',
  'menu.luole-admin.resume.templates': '簡歷模版',
  'menu.luole-admin.job-fair': '招聘會',
  'menu.luole-admin.job-fair.management': '招聘會',
  'menu.luole-admin.job-fair.detail': '招聘會詳情',
  'menu.luole-admin.job-fair.create': '創建招聘會',
  'menu.luole-admin.job-fair.edit': '編輯招聘會',
  'menu.luole-admin.job-fair.info.add': '添加信息',
  'menu.luole-admin.job-fair.info.edit': '編輯信息',
  'menu.luole-admin.schoolShowcase': '高校風采',
  'menu.luole-admin.schoolShowcase.create': '新建高校風采',
  'menu.luole-admin.schoolShowcase.edit': '編輯高校風采',
  'menu.luole-admin.global.dictionary': '職位類別',
  'menu.luole-admin.carousel.management': '輪播圖',
  'menu.luole-admin.contentMarketing.management': '內容行銷',
  'menu.luole-admin.contentMarketing.create': '新建內容',
  'menu.luole-admin.contentMarketing.edit': '編輯內容',
  'menu.luole-admin.task.management': '任務管理',
  'menu.luole-admin.forumRegistration': '論壇報名',
  'menu.luole-admin.jobFairRegistration': '招聘會報名',
  'menu.luole-admin.demoReservation': '企業預約演示',
  'menu.luole-admin.userFeedback': '用戶反饋',
  'menu.luole-admin.registrationChannels': '渠道管理',
  'menu.luole-admin.userFeedback.detail': '反饋詳情',
};
